import { Button, ButtonColorVariant, ButtonSize, ButtonVariant, Modal, ModalSize } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";

import Trans from "@/components/Trans/Trans";

interface IRemoveConversationModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onSubmit: () => Promise<void>;
  isLoading: boolean;
  isMultipleMessagesSelected?: boolean;
}

export function RemoveConversationModal({ isOpen, onOpenChange, isLoading, onSubmit, isMultipleMessagesSelected }: IRemoveConversationModalProps) {
  const { t } = useTranslation();
  const title = isMultipleMessagesSelected
    ? t("conversation:modal.removeMultipleConversation.title")
    : t("conversation:modal.removeConversation.title");
  const description = isMultipleMessagesSelected
    ? t("conversation:modal.removeMultipleConversation.description")
    : t("conversation:modal.removeConversation.description");

  return (
    <Modal
      title={title}
      description={description}
      open={isOpen}
      onOpenChange={onOpenChange}
      dismissable={!isLoading}
      className="gap-md"
      size={ModalSize.LARGE}
    >
      <div className="flex justify-end gap-1.5">
        <Button variant={ButtonVariant.OUTLINED} onClick={() => onOpenChange(false)} size={ButtonSize.LARGE} disabled={isLoading}>
          <Trans i18nKey="common:cancel" />
        </Button>
        <Button onClick={onSubmit} color={ButtonColorVariant.ERROR} loading={isLoading} size={ButtonSize.LARGE}>
          <Trans i18nKey="common:remove" />
        </Button>
      </div>
    </Modal>
  );
}
